import React, { useEffect, useState } from "react";

// import your 32 teeth images
import t1 from "../../../assets/Dental/teeth1.png";
import t2 from "../../../assets/Dental/teeth2.png";
import t3 from "../../../assets/Dental/teeth3.png";
import t4 from "../../../assets/Dental/teeth4.png";
import t5 from "../../../assets/Dental/teeth5.png";
import t6 from "../../../assets/Dental/teeth6.png";
import t7 from "../../../assets/Dental/teeth7.png";
import t8 from "../../../assets/Dental/teeth8.png";
import t9 from "../../../assets/Dental/teeth9.png";
import t10 from "../../../assets/Dental/teeth10.png";
import t11 from "../../../assets/Dental/teeth11.png";
import t12 from "../../../assets/Dental/teeth12.png";
import t13 from "../../../assets/Dental/teeth13.png";
import t14 from "../../../assets/Dental/teeth14.png";
import t15 from "../../../assets/Dental/teeth15.png";
import t16 from "../../../assets/Dental/teeth16.png";
import t17 from "../../../assets/Dental/teeth17.png";
import t18 from "../../../assets/Dental/teeth18.png";
import t19 from "../../../assets/Dental/teeth19.png";
import t20 from "../../../assets/Dental/teeth20.png";
import t21 from "../../../assets/Dental/teeth21.png";
import t22 from "../../../assets/Dental/teeth22.png";
import t23 from "../../../assets/Dental/teeth23.png";
import t24 from "../../../assets/Dental/teeth24.png";
import t25 from "../../../assets/Dental/teeth25.png";
import t26 from "../../../assets/Dental/teeth26.png";
import t27 from "../../../assets/Dental/teeth27.png";
import t28 from "../../../assets/Dental/teeth28.png";
import t29 from "../../../assets/Dental/teeth29.png";
import t30 from "../../../assets/Dental/teeth30.png";
import t31 from "../../../assets/Dental/teeth31.png";
import t32 from "../../../assets/Dental/teeth32.png";

const upperTeeth = [
  t1,
  t2,
  t3,
  t4,
  t5,
  t6,
  t7,
  t8,
  t9,
  t10,
  t11,
  t12,
  t13,
  t14,
  t15,
  t16,
];

const lowerTeeth = [
  t17,
  t18,
  t19,
  t20,
  t21,
  t22,
  t23,
  t24,
  t25,
  t26,
  t27,
  t28,
  t29,
  t30,
  t31,
  t32,
];

export default function Odontogram({ values, setValues, editTrue }) {


  const handleChange = (index, value) => {
    setValues((prev) => {
      const updated = [...prev];
      updated[index] = value;
      return updated;
    });
  };

  // Components
  function SectionTitle({ title }) {
    return (
      <div className="text-center text-teal-400 font-semibold mb-1">
        {title}
      </div>
    );
  }

  function SectionLabels() {
    const sections = [
      { name: "MOLARS", span: 3 },
      { name: "PREMOLARS", span: 2 },
      { name: "CANINE", span: 1 },
      { name: "INCISORS", span: 4 },
      { name: "CANINE", span: 1 },
      { name: "PREMOLARS", span: 2 },
      { name: "MOLARS", span: 3 },
    ];

    return (
      <div
        className="mb-4 text-[10px] text-gray-300 text-center"
        style={{ display: "grid", gridTemplateColumns: "repeat(16, minmax(0, 1fr))", gap: "0.25rem" }}
      >
        {sections.map((sec, i) => (
          <div
            key={i}
            className="border-b border-gray-400/20 text-gray-400/60 pb-1"
            style={{ gridColumn: `span ${sec.span}`, fontSize: 12 }}
          >
            {sec.name}
          </div>
        ))}
      </div>
    );
  }

  function ToothNumbers({ start }) {
    return (
      <div
        className="text-center text-xs text-gray-300 mb-3"
        style={{ display: "grid", gridTemplateColumns: "repeat(16, minmax(0, 1fr))", gap: "0.5rem" }}
      >
        {Array.from({ length: 16 }).map((_, i) => (
          <div key={i} className="flex justify-center">
            {start + i}
          </div>
        ))}
      </div>
    );
  }

  function TeethRow({ images, reverse = false }) {
    const displayed = reverse ? [...images].reverse() : images;
    return (
      <div
        className="mb-6"
        style={{ display: "grid", gridTemplateColumns: "repeat(16, minmax(0, 1fr))", gap: "0.5rem" }}
      >
        {displayed.map((imageSrc, i) => (
          <div key={i} className="flex justify-center">
            <img src={imageSrc} alt="" className="h-14 object-contain" />
          </div>
        ))}
      </div>
    );
  }

  function Legend() {
    return (
      <div className="mt-1 mb-1 border-t border-gray-600 pt-6 text-sm text-gray-300">
        <div className="mb-4 font-medium">Legend:</div>

        <div className="flex flex-wrap gap-4">
          <span>C - Dental Caries</span>
          <span>CO - Composite Filling</span>
          <span>RF - Root Fragment</span>
          <span>Un - Un-erupted</span>
          <span>P - Pontic</span>
          <span>Am - Amalgam Filling</span>
          <span>X - Tooth for Extraction</span>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-4 bg-[#140a5c] text-white">
      {/* TITLE */}
      {/* <div className="text-center py-8">
        <h1 className="text-3xl font-semibold tracking-wide">Odontogram</h1>
      </div> */}

      <div className="max-w-7xl mx-auto px-6">
        {/* UPPER JAW */}
        <SectionTitle title="UPPER JAW" />

        <SectionLabels />

        {/* Upper Inputs */}
        <div
          className="mb-3"
          style={{ display: "grid", gridTemplateColumns: "repeat(16, minmax(0, 1fr))", gap: "0.5rem" }}
        >
          {Array.from({ length: 16 }).map((_, i) => (
            <input
              disabled={editTrue}
              key={i}
              value={values?.[0 + i] || ""}
              onChange={(e) => handleChange(0 + i, e.target.value)}
              className="w-full h-10 rounded-lg bg-gray-200 text-black text-center font-semibold text-sm outline-none"
            />
          ))}
        </div>

        {/* Tooth Numbers */}
        <ToothNumbers start={1} />

        {/* Upper Teeth Images */}
        <TeethRow images={upperTeeth} />

        {/* Lower Teeth Images */}
        <TeethRow images={lowerTeeth} reverse />

        {/* Tooth Numbers */}
        <ToothNumbers start={17} />

        {/* Lower Inputs */}
        {/* <InputsRow
          startIndex={16}
          values={values}
          onChange={handleChange}
        /> */}
        <div
          className="mb-3"
          style={{ display: "grid", gridTemplateColumns: "repeat(16, minmax(0, 1fr))", gap: "0.5rem" }}
        >
          {Array.from({ length: 16 }).map((_, i) => (
            <input
              key={16 + i}
              value={values?.[16 + i] || ""}
              onChange={(e) => handleChange(16 + i, e.target.value)}
              className="w-full h-10 rounded-lg bg-gray-200 text-black text-center font-semibold text-sm outline-none"
            />
          ))}
        </div>

        <SectionLabels />

        {/* LOWER JAW */}
        <SectionTitle title="LOWER JAW" />

        {/* <Legend /> */}
      </div>
    </div>
  );
}
